module.exports = __webpack_public_path__ + "static/media/signature-failed-1.bf330a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/signature-failed-1.png
// module id = 2307
// module chunks = 17